// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import InboxConstants from 'constants/InboxConstants'
import { isEmail } from 'validator'

const InboxActions = Marty.createActionCreators({
  updateInbox(inboxId, params) {
    return this.dispatch(InboxConstants.INBOX_UPDATE, inboxId, params)
  },

  createInbox(params) {
    return this.dispatch(InboxConstants.INBOX_CREATE, params)
  },

  checkIfInboxExistsForEmail(email) {
    if (isEmail(email)) {
      return this.dispatch(InboxConstants.CHECK_INBOX_EXISTENCE_BY_EMAIL, email)
    }
  },

  createWhiteLabelConfiguration(domain) {
    return this.dispatch(InboxConstants.WHITE_LIST_LABELS_CREATE, domain)
  },

  validateWhiteLabelConfiguration(domain) {
    return this.dispatch(InboxConstants.WHITE_LIST_LABELS_VALIDATE, domain)
  },

  archiveInbox(inboxId) {
    return this.dispatch(InboxConstants.INBOX_ARCHIVE, inboxId)
  }
})

export default InboxActions




// WEBPACK FOOTER //
// ./src/scripts/actions/InboxActions.js